module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAMBAMAAABYTmoeAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAALVBMVEUAAADo5Obo5Obo5Obo5Obo5Obo5Obo5Obo5Obo5Obo5Obo5Obo5Obo5Obo5OZItticAAAADnRSTlMAaflC7STYD7oDk5S72Rsfi8IAAAABYktHRACIBR1IAAAACXBIWXMAAAsSAAALEgHS3X78AAAALElEQVQI12MQYGBgUAbiJwEMDO/SgfjFBIZ37xYA8QaGd2+A7OsQOZAaoFoAevkPwWzkibcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ../server/public/static/images/global/type-arrows/right-grey2.png
// module id = 788
// module chunks = 0 1 2 3 4